import { date, mixed, object, string } from 'yup'

export const LoteRegistroValidationSchema = object({
  codigoLote: string().required('Ingrese el Código del Lote'),
  descripcion: string().required('Ingrese una Descripción'),
  fechaAdmision: date().required(),
  fechaFabricacion: date().required(),
  fechaVencimiento: date().required(),
})
